import { useHistory } from "react-router-dom";

const NewTextHeader = ({ isLoginPage }) => {
  const history = useHistory();

  const investNowClick = () => {
    if (isLoginPage) window.location.href = `${process.env.REACT_APP_MOTILAL_MF_MODULE_URL}sip`
    else {
      let redirUrl = `/sip/select-fund?filter=popular`;
      history.push(redirUrl);
    }
  }

  return (
    <div className='countdown-timer-wrapper tw-relative tw-z-[1001] tw-h-[60px] tw-py-2'>
      <div className='countdown-timer-container'>
        <div className='right-section'>
          <h2 className='fund-name'>Don't Time the Market. Take Time in the Market.</h2>
          <div
            // style={{ display: "flex", justifyContent: "center", paddingBottom: "6px" }}
            className='cta-buttons'>
            <button className='cta-invest-button' onClick={investNowClick}>
              Start SIP
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewTextHeader;
